<template>
  <div>
    <div class="columns">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="세부 별점 사용 설정" :useTab="false">
            <div>
              <lp-radio :val="value.enable"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"
                        @onSelect="val=>value.enable=val"></lp-radio>
            </div>
          </admin-box-item>
        </div>
        <div class="box" v-if="value.enable">
          <admin-box-item title="평가 항목 설정" :tip="evaluation_tip" :useTab="false" :titleFlex="true">
            <div class="column is-6" style="text-align: center">
              <div class="flex">
                <div class="column is-1"></div>
                <div class="lp-head column is-5">평가 항목</div>
                <div class="lp-head column is-3">활성화 여부</div>
                <div class="lp-head column is-3">리뷰 개수</div>
                <div class="column is-1"></div>
              </div>
              <draggable v-model="value.items">
                <div class="flex" v-for="(item,idx) in value.items" :key="'item-'+idx">
                  <div class="column is-1" style="color: #bababa">
                    <i class="material-icons lp-drag-indicator" style="line-height:2.5rem;padding:0">
                      drag_indicator
                    </i>
                  </div>
                  <div class="column is-5">
                    <input class="input"
                           :value="item.name"
                           @input="e=>item.name=e.target.value"
                           placeholder="평가 항목을 입력해 주세요."
                           type="text">
                  </div>
                  <div class="column is-3">
                    <toggle-button @change="e=>selectToggle(e,idx)"
                                   :value="item.enable"
                                   :sync="true"
                                   class="changed-font"
                                   :width="70"
                                   :height="24"
                                   :disabled="disabledToggle(item)"
                                   :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                  </div>
                  <div class="column is-3">{{ item.reviews_count }}</div>
                  <div class="column is-1"><i class="material-icons unselect" @click="openDeleteModal(item, idx)">close</i></div>
                </div>
              </draggable>
              <div class="flex justify-center" v-if="value.items.length<10">
                <div class="lp-item-add" @click="addItem">+</div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <modal name="deleteModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="selectedItem">
        <div>{{ selectedItem.name }} 평가 항목을 삭제하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" style="margin-left:0" @click="$modal.hide('deleteModal')">취소</button>
          <button class="button is-primary" style="margin-left:6px;" @click="deleteItem">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpRadio from "../../module/common/LpRadio";
  import draggable from 'vuedraggable'

  export default {
    components: {
      LpRadio,
      draggable,
    },
    name: "product-evaluation-setting",
    data() {
      return {
        value: {
          //사용 설정 여부
          enable: false,
          // 평가 항목
          items: []
        },
        filtering: [
          {
            "set": [
              {
                "value": "",
                "keyword": "params__value_select",
                "operator": "",
                "param_id": 3
              }
            ],
            "type": "choice_radio",
            "label": "전통주 종류",
            "keyword": "params__value_select",
            "is_param": true,
            "param_id": 3,
            "is_active": true,
            "param_name": "전통주 종류",
            "elType": "c-input-radio-full-buttonGroup",
            "value": ""
          },
          {
            "set": [
              {
                "value": 50,
                "keyword": "params__value_float",
                "operator": "__gte",
                "param_id": 4
              },
              {
                "value": 100,
                "keyword": "params__value_float",
                "operator": "__lte",
                "param_id": 4
              }
            ],
            "type": "number_range",
            "label": "도수",
            "keyword": "params__value_float",
            "is_param": true,
            "param_id": 4,
            "is_active": true,
            "param_name": "도수",
            "elType": "c-input-range",
            "value": [
              50,
              100
            ]
          },
          {
            "set": [
              {
                "value": 1,
                "keyword": "params__value_linear",
                "operator": "__gte",
                "param_id": 1
              },
              {
                "value": 10,
                "keyword": "params__value_linear",
                "operator": "__lte",
                "param_id": 1
              }
            ],
            "type": "number_range",
            "label": "신맛",
            "keyword": "params__value_linear",
            "is_param": true,
            "param_id": 1,
            "is_active": true,
            "param_name": "신맛",
            "elType": "c-input-range",
            "value": [
              1,
              10
            ]
          },
          {
            "set": [
              {
                "value": 1,
                "keyword": "params__value_linear",
                "operator": "__gte",
                "param_id": 2
              },
              {
                "value": 10,
                "keyword": "params__value_linear",
                "operator": "__lte",
                "param_id": 2
              }
            ],
            "type": "number_range",
            "label": "단맛",
            "keyword": "params__value_linear",
            "is_param": true,
            "param_id": 2,
            "is_active": true,
            "param_name": "단맛",
            "elType": "c-input-range",
            "value": [
              1,
              10
            ]
          },
          {
            "set": [
              {
                "value": 1,
                "keyword": "params__value_linear",
                "operator": "__gte",
                "param_id": 5
              },
              {
                "value": 10,
                "keyword": "params__value_linear",
                "operator": "__lte",
                "param_id": 5
              }
            ],
            "type": "number_range",
            "label": "바디감",
            "keyword": "params__value_linear",
            "is_param": true,
            "param_id": 5,
            "is_active": true,
            "param_name": "바디감",
            "elType": "c-input-range",
            "value": [
              1,
              10
            ]
          },
          {
            "set": [
              {
                "value": "",
                "keyword": "params__value_select",
                "operator": "",
                "param_id": 6
              }
            ],
            "type": "choice_radio",
            "label": "양조지역",
            "keyword": "params__value_select",
            "is_param": true,
            "param_id": 6,
            "is_active": true,
            "param_name": "양조지역",
            "elType": "c-input-radio-full-buttonGroup",
            "value": ""
          },
          {
            "set": [
              {
                "value": [],
                "keyword": "params__value_select",
                "operator": "__in",
                "param_id": 7
              }
            ],
            "type": "choice_checkbox",
            "label": "어울리는 음식",
            "keyword": "params__value_select",
            "is_param": true,
            "param_id": 7,
            "is_active": true,
            "param_name": "어울리는 음식",
            "elType": "CInputCheckboxFullGroup",
            "value": []
          }
        ],
        selectedItem: undefined,
        evaluation_tip: "<div>- 등록은 최대 10개까지 가능하며, '사용' 상태로 활성화는 최대 5개까지 설정 가능합니다.</div><br>" +
        "<div>- 최소 2개의 항목이 '사용함'상태여야 합니다.</div><br>" +
        "<div>- 평가 항목을 '미사용'으로 비활성화 할 경우, 기존에 작성된 리뷰에서는 비활성화된 평가가 표시되지 않습니다.</div>"
      }
    },
    created() {
      this.getData();
      this.getProduct();
    },
    watch: {
      'value.items'(n) {
        for(let i=0; i<n.length; i++) {
          n[i].priority=i;
        }
      }
    },
    methods: {
      getProduct() {
        let url = 'http://localhost:8000/user/1/mapping/product'
        this.$axios.post(url, {
          fields:'id',
          filtering:JSON.stringify(this.filtering),
          standard:'product',
          ordering: '-created_time'
        }).then(res=> {
          console.log(res.data)
        })
      },
      disabledToggle(item) {
        let count = 0;
        this.value.items.forEach(item=> {
          if(item.enable) count += 1;
        })
        if(count<5) {
          return false
        }
        else {
          if(!item.enable) return true;
          else return false;
        }
      },
      selectToggle(e,idx) {
        this.value.items[idx].enable = e.value;
      },
      getData() {
        this.$axios.get(this.getUrl('product/evaluation/setting')).then(res=> {
          this.value = res.data;
        })
      },
      addItem() {
        this.value.items.push({name: '', enable: false, reviews_count: 0, prioryty: this.value.items.length-1});
      },
      openDeleteModal(item, idx) {
        if(!item.id) {
          removeIndex(this.value.items,idx);
          return;
        }
        this.selectedItem = item;
        this.$modal.show('deleteModal');
      },
      deleteItem() {
        this.$axios.delete(this.getUrl(`product/evaluation/item/${this.selectedItem.id}`), this.value).then(res=> {
          if(res.status===200) {
            this.toast('삭제되었습니다.')
            this.$modal.hide('deleteModal');
            this.getData();
          }
        });
      },
      saveData() {
        let count = 0;
        this.value.items.forEach(item=> {
          if(item.enable) count += 1;
        });
        if(count<2) {
          this.toast("최소 2개의 항목이 '사용함' 상태여야 합니다.");
          return;
        }
        this.$axios.post(this.getUrl('product/evaluation/setting'), this.value).then(res=> {
          if(res.status===200) {
            this.toast('저장되었습니다.');
            this.getData();
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-head
    color #363636
    font-weight bold

  .lp-item-add
    width 58px
    height 30px
    border-radius 3px
    text-align center
    cursor pointer
    font-size 20px
    border 1px solid
</style>
